import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=159d8c66&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=159d8c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159d8c66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('159d8c66')) {
      api.createRecord('159d8c66', component.options)
    } else {
      api.reload('159d8c66', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=159d8c66&scoped=true&", function () {
      api.rerender('159d8c66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/liff_access/Settings.vue"
export default component.exports